// extracted by mini-css-extract-plugin
export default {"root":"CustomerForm_root__WZj5D","headerBar":"CustomerForm_headerBar__-UxF2","headerText":"CustomerForm_headerText__Fh5Fz"};